import React from "react";
import "../template-file-css/document-file-template.css";

export const NBT_6MonthReassessment = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='NBT_6MonthReassessment' className='file-pdf-document'>
            <div className='file-template'>

                <table>
                    <tr>
                        <td className="w-250">
                            <span className="eleHeader">Emergency Contact:</span>
                            <input type="text" id="txtEmergencyContact" name="txtEmergencyContact" className="add-only" />
                        </td>
                        <td className="w-250">
                            <span className="eleHeader">Relationship:</span>
                            <input type="text" id="txtEmergencyRelationship" name="txtEmergencyRelationship" className="add-only" />
                        </td>
                        <td className="w-250">
                            <span className="eleHeader">Contact Phone:</span>
                            <input type="text" id="txtEmergencyPhone" name="txtEmergencyPhone" className="add-only" />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className="w-750"><span className="eleHeader">Insurance Information</span></td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <input type="checkbox" id="cbMedicaidStandard" name="cbMedicaidStandard" className="add-only" value="Medicaid Standard" /> Medicaid Standard: <input id="txtMedicaidStandard" name="txtMedicaidStandard" className="add-only" />
                        </td>
                        <td className="w-375">
                            <input type="checkbox" id="cbCenpatico" name="cbCenpatico" className="add-only" value="Cenpatico" /> Cenpatico: <input id="txtCenpatico" name="txtCenpatico" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <input type="checkbox" id="cbAmerigroup" name="cbAmerigroup" className="add-only" value="Amerigroup" /> Amerigroup:
                            <input id="txtAmerigroup" name="txtAmerigroup" className="add-only" />
                        </td>
                        <td className="w-375">
                            <input type="checkbox" id="cbWellcare" name="cbWellcare" className="add-only" value="Wellcare" /> Wellcare:
                            <input id="txtWellcare" name="txtWellcare" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type="checkbox" id="cbFeeForServices" name="cbFeeForServices" className="add-only" value="None/Fee-for-Services" /> None/Fee-for-Services
                        </td>
                        <td>&nbsp;</td>
                    </tr>
                </table>
                <h5>Referral Information</h5>
                <table>
                    <tr>
                        <td className="w-375">
                            <span className="eleHeader">Name/Relationship to Child:</span>
                            <input type="text" id="txtReferralName" name="txtReferralName" className="add-only" />
                        </td>
                        <td className="w-375">
                            <span className="eleHeader">Contact Number:</span>
                            <input type="text" id="txtReferralNumber" name="txtReferralNumber" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <span className="eleHeader">Email Address:</span>
                            <input type="text" id="txtReferralEmail" name="txtReferralEmail" className="add-only" />
                        </td>
                        <td className="w-375">&nbsp;</td>
                    </tr>
                </table>

                <p >
                    <span className="eleHeader">Presenting Problems:</span>
                    <span className="small">(Brief statement of current mental health symptoms; conduct; behaviors and concerns)</span>
                    <textarea id="txtPresentingProblems" name="txtPresentingProblems" className="add-only" rows="5"></textarea>
                </p>
                <p >
                    <span className="eleHeader">Describe client's personality as per informant:</span>
                    <span className="small">(Management of anger, problem solving/coping skills, impulsivity, peer relationships
                        and self-esteem, History of temper tantrums/rapid mood swings)</span>
                    <textarea id="txtDescribePersonality" name="txtDescribePersonality" className="add-only" rows="5"></textarea>
                </p>
                <p >
                    <span className="eleHeader">Any use of Addictive Substances and Tobacco since previous assessment:</span>
                    <span className="small">(If so, list the name of the substance, age of 1st use, frequency/amount used, date of last use)</span>
                    <textarea id="txtSAUse" name="txtSAUse" className="add-only" rows="5"></textarea>
                </p>
                <p >
                    <span className="eleHeader">Criminal behavior since previous assessment:</span>
                    <span className="small">(Include any Juvenile Offenses i.e. “Unruly”, “Run Away”)</span>
                    <textarea id="txtCriminalBehavior" name="txtCriminalBehavior" className="add-only" rows="5"></textarea>
                </p>
                <p >
                    <span className="eleHeader">Describe involvement with community agencies since previous assessment:</span>
                    <span className="small">(DFCS, DJJ, etc. – list contact person, phone number and time period)</span>
                    <textarea id="txtCommAgencyInvolvement" name="txtCommAgencyInvolvement" className="add-only" rows="5"></textarea>
                </p>
                <p >
                    <span className="eleHeader">Has the child been involved with or has any Mental Health and/or Psychiatric
                        Interventions since previous assessment?:</span>
                    <span className="small">(List name of provider, contact information and length of treatment)</span>
                    <textarea id="txtChildInvolved" name="txtChildInvolved" className="add-only" rows="5"></textarea>
                </p>
                <p >
                    <span className="eleHeader">Describe relationship with peers:</span>
                    <span className="small">(Best Friend? Same / opposite sex: Consumer is known to get
                        along with his peers; however when he is angry, he becomes combative and aggressive.)</span>
                    <textarea id="txtDescribePeerRelationship" name="txtDescribePeerRelationship" className="add-only" rows="5"></textarea>
                </p>
                <h3>Family History</h3>
                <table>
                    <tr>
                        <td className="w-750"><span className="eleHeader">History Composition</span>
                            <span className="small">*Anyone that moves in and out of home*</span></td>
                    </tr>
                    <tr>
                        <td className="w-187 font-weight:bold;">  Name</td>
                        <td className="w-187 font-weight:bold;">  Relationship</td>
                        <td className="w-187 font-weight:bold;">  DOB/Age</td>
                        <td className="w-187 font-weight:bold;">  Occupation</td>
                    </tr>
                    <tr>
                        <td className="w-187"><input type="text" id="txtFamilyHistory_Name_1" name="txtFamilyHistory_Name_1" className="add-only" /></td>
                        <td className="w-187"><input type="text" id="txtFamilyHistory_Relationship_1" name="txtFamilyHistory_Relationship_1" className="add-only" /></td>
                        <td className="w-187"><input type="text" id="txtFamilyHistory_Age_1" name="txtFamilyHistory_Age_1" className="add-only" /></td>
                        <td className="w-187"><input type="text" id="txtFamilyHistory_Occupation_1" name="txtFamilyHistory_Occupation_1" className="add-only" /></td>
                    </tr>
                    <tr>
                        <td className="w-187"><input type="text" id="txtFamilyHistory_Name_2" name="txtFamilyHistory_Name_2" className="add-only" /></td>
                        <td className="w-187"><input type="text" id="txtFamilyHistory_Relationship_2" name="txtFamilyHistory_Relationship_2" className="add-only" /></td>
                        <td className="w-187"><input type="text" id="txtFamilyHistory_Age_2" name="txtFamilyHistory_Age_2" className="add-only" /></td>
                        <td className="w-187"><input type="text" id="txtFamilyHistory_Occupation_2" name="txtFamilyHistory_Occupation_2" className="add-only" /></td>
                    </tr>
                    <tr>
                        <td className="w-187"><input type="text" id="txtFamilyHistory_Name_3" name="txtFamilyHistory_Name_3" className="add-only" /></td>
                        <td className="w-187"><input type="text" id="txtFamilyHistory_Relationship_3" name="txtFamilyHistory_Relationship_3" className="add-only" /></td>
                        <td className="w-187"><input type="text" id="txtFamilyHistory_Age_3" name="txtFamilyHistory_Age_3" className="add-only" /></td>
                        <td className="w-187"><input type="text" id="txtFamilyHistory_Occupation_3" name="txtFamilyHistory_Occupation_3" className="add-only" /></td>
                    </tr>
                    <tr>
                        <td className="w-187"><input type="text" id="txtFamilyHistory_Name_4" name="txtFamilyHistory_Name_4" className="add-only" /></td>
                        <td className="w-187"><input type="text" id="txtFamilyHistory_Relationship_4" name="txtFamilyHistory_Relationship_4" className="add-only" /></td>
                        <td className="w-187"><input type="text" id="txtFamilyHistory_Age_4" name="txtFamilyHistory_Age_4" className="add-only" /></td>
                        <td className="w-187"><input type="text" id="txtFamilyHistory_Occupation_4" name="txtFamilyHistory_Occupation_4" className="add-only" /></td>
                    </tr>
                    <tr>
                        <td className="w-187"><input type="text" id="txtFamilyHistory_Name_5" name="txtFamilyHistory_Name_5" className="add-only" /></td>
                        <td className="w-187"><input type="text" id="txtFamilyHistory_Relationship_5" name="txtFamilyHistory_Relationship_5" className="add-only" /></td>
                        <td className="w-187"><input type="text" id="txtFamilyHistory_Age_5" name="txtFamilyHistory_Age_5" className="add-only" /></td>
                        <td className="w-187"><input type="text" id="txtFamilyHistory_Occupation_5" name="txtFamilyHistory_Occupation_5" className="add-only" /></td>
                    </tr>
                    <tr>
                        <td className="w-187"><input type="text" id="txtFamilyHistory_Name_6" name="txtFamilyHistory_Name_6" className="add-only" /></td>
                        <td className="w-187"><input type="text" id="txtFamilyHistory_Relationship_6" name="txtFamilyHistory_Relationship_6" className="add-only" /></td>
                        <td className="w-187"><input type="text" id="txtFamilyHistory_Age_6" name="txtFamilyHistory_Age_6" className="add-only" /></td>
                        <td className="w-187"><input type="text" id="txtFamilyHistory_Occupation_6" name="txtFamilyHistory_Occupation_6" className="add-only" /></td>
                    </tr>
                </table>
                <p >
                    <span className="eleHeader">Family Relationship:</span>
                    <span className="small">(How does the child get along with each family member? Has the guardianship changed within
                        the past year? Are there any safety issues, domestic violence, custody or abuse issues? How are problems handled?)</span>
                    <textarea id="txtFamilyRelationship" name="txtFamilyRelationship" className="add-only" rows="5"></textarea>
                </p>
                <p >
                    <span className="eleHeader">Describe behavior management techniques utilized with child:</span>
                    <span className="small">(Include the “type” of discipline and who is the primary disciplinarian)</span>
                    <textarea id="txtBxManagementTechniques" name="txtBxManagementTechniques" className="add-only" rows="5"></textarea>
                </p>
                <p >
                    <span className="eleHeader">Family's source(s) of income:</span>
                    <span className="small">(Has income changed since initial assessment? Any job changes since initial assessment)</span>
                    <textarea id="txtFamilyIncomeSource" name="txtFamilyIncomeSource" className="add-only" rows="5"></textarea>
                </p>
                <p >
                    <span className="eleHeader">Have there been any major family stressors during the past six months?:</span>
                    <span className="small">(Have there been any major family stressors during the past six months?)</span>
                    <textarea id="txtMajorFamilyStressors" name="txtMajorFamilyStressors" className="add-only" rows="5"></textarea>
                </p>
                <p >
                    <span className="eleHeader">Any significant family medical and / or psychiatric history since previous assessment:</span>
                    <textarea id="txtSignificantFamilyMed" name="txtSignificantFamilyMed" className="add-only" rows="5"></textarea>
                </p>
                <p >
                    <span className="eleHeader">Is there anyone who is prohibited with having contact with the client, or for
                        whom contact is limited?:</span>
                    <textarea id="txtProhibitedFromContact" name="txtProhibitedFromContact" className="add-only" rows="5"></textarea>
                </p>
                <h3>Medical/Psychological</h3>
                <p >
                    <span className="eleHeader">Significant illnesses, injuries for client since previous assessment:</span>
                    <textarea id="txtSignificantIllness" name="txtSignificantIllness" className="add-only" rows="5"></textarea>
                </p>
                <table>
                    <tr>
                        <td className="w-375">
                            <span className="eleHeader">Date of Last Physical:</span>
                            <input type="date" id="txtLastPhysicalDate" name="txtLastPhysicalDate" className='add-only' />
                        </td>
                        <td className="w-375">
                            <span className="eleHeader">Name of Physician:</span>
                            <input type="text" id="txtPhysicianName" name="txtPhysicianName" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <span className="eleHeader">Date of Last Dental:</span>
                            <input type="date" id="txtLastDentalDate" name="txtLastDentalDate" className='add-only' />
                        </td>
                        <td className="w-375">
                            <span className="eleHeader">Name of Dentist:</span>
                            <input type="text" id="txtDentistName" name="txtDentistName" className="add-only" />
                        </td>
                    </tr>
                </table>
                <p >
                    <span className="eleHeader">Are there any current medical / dental complaints?:</span>
                    <textarea id="txCurrentMedDentalComplaints" name="txCurrentMedDentalComplaints" className="add-only" rows="5"></textarea>
                </p>
                <p >
                    <span className="eleHeader">Are there any current medications / prescribing physician?:</span>
                    <textarea id="txtCurrentMedsPhysician" name="txtCurrentMedsPhysician" className="add-only" rows="5"></textarea>
                </p>
                <p >
                    <span className="eleHeader">List current psychotropic medications prescribed (length / dates of usage / impact):</span>
                    <textarea id="txtPsychotropicMeds" name="txtPsychotropicMeds" className="add-only" rows="5"></textarea>
                </p>
                <h3>Risk and Trauma Assessment</h3>
                <p >
                    <span className="eleHeader">Suicidal/Homicidal Ideation:</span>
                    <span className="small">(Since previous assessment)</span>
                    <textarea id="txtIdeation" name="txtIdeation" className="add-only" rows="5"></textarea>
                </p>
                <p >
                    <span className="eleHeader">Self-Injurious Behavior:</span>
                    <span className="small">(Since previous assessment)</span>
                    <textarea id="txtSelfInjurious" name="txtSelfInjurious" className="add-only" rows="5"></textarea>
                </p>
                <p >
                    <span className="eleHeader">Severely Aggressive Ideation/Behavior:</span>
                    <span className="small">(Since previous assessment)</span>
                    <textarea id="txtAggressiveIdeation" name="txtAggressiveIdeation" className="add-only" rows="5"></textarea>
                </p>
                <p >
                    <span className="eleHeader">Feelings of persecution:</span>
                    <span className="small">(Does the client report feeling like people are “plotting against”,
                        “planning to harm him” or “out-to-get” him?)</span>
                    <textarea id="txtPersecutionFeelings" name="txtPersecutionFeelings" className="add-only" rows="5"></textarea>
                </p>
                <p >
                    <span className="eleHeader">Delusions / Hallucinations:</span>
                    <span className="small">(Does the client report seeing, smelling or hearing things people, odors
                        or sounds that others don't?)</span>
                    <textarea id="txtDelusions" name="txtDelusions" className="add-only" rows="5"></textarea>
                </p>
                <p >
                    <span className="eleHeader">Obsessive/Compulsive Behaviors:</span>
                    <span className="small">(Does the client experience uncontrollable, unwanted thoughts
                        and repetitive, ritualized behaviors they feel compelled to perform?)</span>
                    <textarea id="txtOCD" name="txtOCD" className="add-only" rows="5"></textarea>
                </p>
                <p >
                    <span className="eleHeader">Post-traumatic stress disorder:</span>
                    <span className="small">(Has the client seen or experienced a traumatic event that involved
                        the threat of injury or death?)</span>
                    <textarea id="txtPTSD" name="txtPTSD" className="add-only" rows="5"></textarea>
                </p>
                <p >
                    <span className="eleHeader">Dissociations:</span>
                    <span className="small">(Does the client have thoughts or emotions seemingly coming out of nowhere, or
                        carrying out an action as if it were controlled by a force outside of self?)</span>
                    <textarea id="txtDissociations" name="txtDissociations" className="add-only" rows="5"></textarea>
                </p>
                <p >
                    <span className="eleHeader">Any changes in sleep pattern since previous assessment?:</span>
                    <textarea id="txtSleepPatternChanges" name="txtSleepPatternChanges" className="add-only" rows="5"></textarea>
                </p>
                <p >
                    <span className="eleHeader">Any changes in eating habits since previous assessment?:</span>
                    <textarea id="txtEatingChanges" name="txtEatingChanges" className="add-only" rows="5"></textarea>
                </p>
                <p >
                    <span className="eleHeader">Other psychosocial or environmental problems:</span>
                    <textarea id="txtPSProblems" name="txtPSProblems" className="add-only" rows="5"></textarea>
                </p>
                <p >
                    <span className="eleHeader">School History:</span>
                    <span className="small">(What school does the child attend? What grade? Has the child changed schools since previous
                        assessment? Has the child received additional school services since previous assessment?)</span>
                    <textarea id="txtSchoolHistory" name="txtSchoolHistory" className="add-only" rows="5"></textarea>
                </p>
                <p >
                    <span className="eleHeader">Client's choice and hopes for recovery:</span>
                    <span className="small">(What does the client want to work on in treatment?)</span>
                    <textarea id="txtClientChoice" name="txtClientChoice" className="add-only" rows="5"></textarea>
                </p>
                <p >
                    <span className="eleHeader">Strengths:</span>
                    <textarea id="txtStrengths" name="txtStrengths" className="add-only" rows="5"></textarea>
                </p>
                <p >
                    <span className="eleHeader">Needs:</span>
                    <textarea id="txtNeeds" name="txtNeeds" className="add-only" rows="5"></textarea>
                </p>
                <p >
                    <span className="eleHeader">Abilities:</span>
                    <textarea id="txtAbilities" name="txtAbilities" className="add-only" rows="5"></textarea>
                </p>
                <p >
                    <span className="eleHeader">Preferences:</span>
                    <textarea id="txtPreferences" name="txtPreferences" className="add-only" rows="5"></textarea>
                </p>
                <h3>General Appearance/Functions</h3>
                <p >
                    <span className="eleHeader">Appearance and Behavior:</span>
                    <textarea id="txtAppearanceBehavior" name="txtAppearanceBehavior" className="add-only" rows="5"></textarea>
                </p>
                <p >
                    <span className="eleHeader">Mood and Affect:</span>
                    <textarea id="txtMoodAffect" name="txtMoodAffect" className="add-only" rows="5"></textarea>
                </p>
                <table>
                    <tr>
                        <td className="w-300"><span className="eleHeader">CAFAS Information</span></td>
                        <td className="w-450"><span className="eleHeader">Scale Score</span></td>
                    </tr>
                    <tr>
                        <td className="w-300">School/Work</td>
                        <td className="w-450"><input type="text" id="txtCAFAS_School" name="txtCAFAS_School" className="add-only" /></td>
                    </tr>
                    <tr>
                        <td className="w-300">Home</td>
                        <td className="w-450"><input type="text" id="txtCAFAS_Home" name="txtCAFAS_Home" className="add-only" /></td>
                    </tr>
                    <tr>
                        <td className="w-300">Community</td>
                        <td className="w-450"><input type="text" id="txtCAFAS_Community" name="txtCAFAS_Community" className="add-only" /></td>
                    </tr>
                    <tr>
                        <td className="w-300">Behavior Towards Others</td>
                        <td className="w-450"><input type="text" id="txtCAFAS_BxTowardsOthers" name="txtCAFAS_BxTowardsOthers" className="add-only" /></td>
                    </tr>
                    <tr>
                        <td className="w-300">Moods/Emotions</td>
                        <td className="w-450"><input type="text" id="txtCAFAS_Moods" name="txtCAFAS_Moods" className="add-only" /></td>
                    </tr>
                    <tr>
                        <td className="w-300">Self-Harm Behaviors</td>
                        <td className="w-450"><input type="text" id="txtCAFAS_SelfHarm" name="txtCAFAS_SelfHarm" className="add-only" /></td>
                    </tr>
                    <tr>
                        <td className="w-300">Substance Use</td>
                        <td className="w-450"><input type="text" id="txtCAFAS_SubstanceUse" name="txtCAFAS_SubstanceUse" className="add-only" /></td>
                    </tr>
                    <tr>
                        <td className="w-300">Thinking</td>
                        <td className="w-450"><input type="text" id="txtCAFAS_Thinking" name="txtCAFAS_Thinking" className="add-only" /></td>
                    </tr>
                    <tr>
                        <td className="w-300">Total Score</td>
                        <td className="w-450"><input type="text" id="txtCAFAS_Total" name="txtCAFAS_Total" className="add-only" /></td>
                    </tr>
                </table>
                <p >
                    <span className="eleHeader">CAFAS Narrative:</span>
                    <textarea id="txtCAFASNarrative" name="txtCAFASNarrative" className="add-only" rows="5"></textarea>
                </p>
                <h3>Diagnostic Impression</h3>
                <h3>ICD-10</h3>
                <table>
                    <tr>
                        <td className="w-375">
                            <span className="eleHeader">AXIS I:</span>
                            <input type="text" id="txtAXISI" name="txtAXISI" className="add-only" />
                        </td>
                        <td className="w-375">
                            <span className="eleHeader">AXIS II:</span>
                            <input type="text" id="txtAXISII" name="txtAXISII" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <span className="eleHeader">AXIS III:</span>
                            <input type="text" id="txtAXISIII" name="txtAXISIII" className="add-only" />
                        </td>
                        <td className="w-375">
                            <span className="eleHeader">AXIS IV:</span>
                            <input type="text" id="txtAXISIV" name="txtAXISIV" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <span className="eleHeader">AXIS V - GAF:</span>
                            <input type="text" id="txtAXISV" name="txtAXISV" className="add-only" />
                        </td>
                        <td className="w-375">&nbsp;</td>
                    </tr>
                </table>
                <p >
                    <span className="eleHeader">Recommendations from this evaluation:</span>
                    <span className="small">(Services being recommended &#45; ind., family; identify what
                        resources/interventions are needed to help in successfully moving the client through the process;
                        interventions that NBT can offer and community-based needs; identify whether IFI or Core Services
                        and concluding statement)</span>
                    <textarea id="txtRecommendations" name="txtRecommendations" className="add-only" rows="5"></textarea>
                </p>
                <p >
                    <span className="eleHeader">Transitional Considerations for Discharge Plan:</span>
                    <span className="small">(Define the indicators that will determine when the client is ready to
                        began to transition from recommended level of care)</span>
                    <textarea id="txtTransitionalConsiderations" name="txtTransitionalConsiderations" className="add-only" rows="5"></textarea>
                </p>
                <p >
                    <span className="eleHeader">Interpretative Summary:</span>
                    <span className="small">(Include an analysis of the client's symptoms/behaviors; client's perception of his/her need for
                        services; Diagnostic Impression: Client's choice and hopes for recovery; SNAP; Transitional
                        Discharge; identify whether IFI or Core Services and concluding statement)</span>
                    <textarea id="txtInterpretativeSummary" name="txtInterpretativeSummary" className="add-only" rows="5"></textarea>
                </p>
                <table>
                    <tr>
                        <td className="w-600 signature">&nbsp;</td>
                        <td className="w-150 signature">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-600 small"> Assessor/Credentials</td>
                        <td className="w-150 small"> Date</td>
                    </tr>
                </table>
            </div>
        </form>
    )
}